var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{class:_vm.alignClass,on:{"click":_vm.onSort}},[_c('button',{class:_vm.alignClass,attrs:{"disabled":!_vm.sortable}},[_c('span',[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.sortable),expression:"sortable"}],class:_vm.sortIcon})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3293d3e8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/grid/ms-grid-header-item.vue
// module id = null
// module chunks = 